const mobileSwapX       = 1200
const transHeaderSwapY  = 0
let subNavVisible       = false
let bodyEl              = null
let mobileVpWidth       = null
let transHeader         = null
let mobileNavIsVisible  = false
let mobileNavWrapEl     = null
let mobileNavOpenBtn    = null
let mobileNavCloseBtn   = null
let subNavOpenBtn       = null
let subNavWrap          = null
let subNavCloseBtn      = null


// We need a .closest polyfill for IE9.
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector ||  Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this
    do {
      if (el.matches(s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}


export function initialize() {
  bodyEl            = document.querySelector('body')
  transHeader       = document.querySelector('[data-is-transparent]')
  mobileNavWrapEl   = document.querySelector('[data-nav-wrap]')
  mobileNavOpenBtn  = document.querySelector('[data-nav-open]')
  mobileNavCloseBtn = document.querySelector('[data-nav-close]')
  subNavOpenBtn     = [...document.querySelectorAll('[data-sub-nav-open]')]
  subNavWrap        = [...document.querySelectorAll('[data-sub-nav-wrap]')]
  subNavCloseBtn    = [...document.querySelectorAll('[data-sub-nav-close]')]
  addListeners()
  betterResize()
}


export function addListeners() {
  window.addEventListener('resizeViaRAF', handleResize, false)
  document.addEventListener('keyup', handleKeyPresses, false)
  mobileNavOpenBtn.addEventListener('click', toggleNav, false)
  mobileNavCloseBtn.addEventListener('click', toggleNav, false)
  subNavOpenBtn.forEach(function(el){el.addEventListener('click', toggleSubNav, false)})
  subNavCloseBtn.forEach(function(el){el.addEventListener('click', closeAllSubNavs, false)})
  if (transHeader && window.innerWidth >= mobileSwapX) {
    window.addEventListener('scroll', handleScroll, false)
  }
}


// Handle viewport resizing via requestAnimationFrame.
export function betterResize() {
  let running = false
  function doItViaRAF() {
    if (running) {return}
    running = true
    requestAnimationFrame(function() {
      window.dispatchEvent(new CustomEvent('resizeViaRAF'))
      running = false
    })
  }
  window.addEventListener('resize', doItViaRAF)
}


// Utilized when the viewport alternates between mobile and desktop widths.
export function handleResize() {
  mobileVpWidth = window.innerWidth
  if ((mobileVpWidth >= mobileSwapX) && mobileNavIsVisible) {
    toggleNav(event)
  }
}


// Handle keypresses. Currently, this will close the mobile nav when the escape
// key is pressed. Extend it further as needed.
export function handleKeyPresses(event) {
  if (mobileNavIsVisible && (event.keyCode === 27)) {
    toggleNav(event)
  }
}


// Toggle mobile (only) nav.
export function toggleNav(event) {
  mobileNavWrapEl.classList.toggle('is-visible')
  mobileNavIsVisible = !mobileNavIsVisible
  event.stopPropagation()
  closeAllSubNavs()
}


// Toggle each and every sub-nav. Utilized at all viewport widths.
export function toggleSubNav() {
  // 1. Find button's nearest parent container.
  let parentContainer = this.closest('[data-nav-group]')
  // 2. Determine whether or not button's sub-nav was *already* visible.
  subNavVisible = parentContainer.querySelector('[data-sub-nav-wrap]').classList.contains('is-visible')
  // 3. Close any/all sub-navs.
  closeAllSubNavs()
  // 4a. If button's sub-nav was not already open...
  if (!subNavVisible) {
    // ...open it...
    this.setAttribute('aria-expanded', true)
    parentContainer.querySelector('[data-sub-nav-wrap]').classList.add('is-visible')
    // ...and, if we're operating on a header that can be transparent...
    if (transHeader) {
      // ...set the header to opaque.
      setHeaderOpaque()
    }
    //...and update the variable to say that the sub-nav is now visible.
    subNavVisible = true
  }
  // 4b. Otherwise, set the variable to say that the sub-nav is not visible,
  // and ensure the button loses focus.
  else {
    subNavVisible = false
    this.blur()
  }
}


// Close all sub-navs.
export function closeAllSubNavs() {
  // 1. Set each button's aria-expanded value to false.
  subNavOpenBtn.forEach(function(el) {
    if (el.getAttribute('aria-expanded') !== false) {
      el.setAttribute('aria-expanded', false)
    }
  })
  // 2. Close/hide every open sub-nav.
  subNavWrap.forEach(function(el) {
    if (el.classList.contains('is-visible')) {
      el.classList.remove('is-visible')
    }
  })
  // 3. If the header can be made transparent *and* the page is scrolled all
  //    of the way to the top of the viewport...
  if (transHeader && bodyEl.getBoundingClientRect().top === transHeaderSwapY) {
    // ...make that header transparent.
    setHeaderTransparent()
  }
}


// Deal with scrolling. Note, this function isn't even utilized unless two
// things are true (defined up in addListeners()):
// 1. the page currently has a header that can be transparent, and
// 2. the viewport is wide enough to *not* be in "mobile" mode.
export function handleScroll() {
  requestAnimationFrame(function() {
    // If the page is scrolled down any amout at all...
    if (bodyEl.getBoundingClientRect().top < transHeaderSwapY) {
      // ...set the header to opaque.
      setHeaderOpaque()
    }
    // ...otherwise...
    else if (!subNavVisible) {
      // ...set the header to transparent.
      setHeaderTransparent()
    }
  })
}


export function setHeaderOpaque() {
  transHeader.classList.add('is-opaque')
}


export function setHeaderTransparent() {
  transHeader.classList.remove('is-opaque')
}
